<script>
export default {
  props: {
    tableData: {
      type: Array,
      default () {
        return []
      }
    },
    isShowBusinessCard: Boolean,
    cardImageData: String
  },
  computed: {
    tableShowData () {
      return this.tableData[0]
    },
    mainInsurance () {
      if (!this.tableShowData || !Array.isArray(this.tableShowData.tableList)) {
        return {}
      }
      return this.tableShowData.tableList[0]
    },
    liabilityByCategory () {
      return this.getLiabilitiesComponents(this.tableShowData)
    }
  },
  methods: {
    getLiabilitiesComponents ({ tableList, categorySort }) {
      const liabilities = tableList.reduce((accumulate, item) => {
        return accumulate.concat((item.liability || []).filter(t => t.parsedDesc1))
      }, [])

      function buildLiabilityItems (categoryId) {
        const liabilityItem = liabilities.filter(
          it => it && it.categoryId === categoryId
        )
        if (!liabilityItem.length) return

        const normalizedData = liabilityItem.reduce(
          (accumulate, item) => {
            if (Array.isArray(item.childTags) && item.childTags.length) {
              item.childTags.forEach(({ tagName }) => {
                accumulate.data[tagName] = Array.isArray(
                  accumulate.data[tagName]
                )
                  ? accumulate.data[tagName].concat(item)
                  : [item]
              })
            } else {
              accumulate.notag = Array.isArray(accumulate.notag)
                ? accumulate.notag.concat(item)
                : [item]
            }
            return accumulate
          },
          { data: {} }
        )
        const keysLen = Object.keys(normalizedData.data).length
        if (keysLen < 1) {
          normalizedData.data = null
        }
        // data.length + notag
        normalizedData.rowspan = keysLen + (normalizedData.notag ? 1 : 0)
        normalizedData.categoryName = liabilityItem[0].categoryName

        return normalizedData
      }

      return categorySort ? categorySort.reduce((accumulate, item) => {
        const items = buildLiabilityItems(item) || []
        return accumulate.concat(items)
      }, []) : []
    }
  }
}
</script>
<template>
  <div @click="$emit('view')">
    <div class="table-title">
      <h2>
        {{ tableShowData.insuredInfo.name || (tableShowData.insuredInfo.sexDesc + tableShowData.insuredInfo.age + '岁') }}的专属保障计划
      </h2>
    </div>
    <table v-if="tableShowData" class="table-layout">
      <thead>
        <tr>
          <th>保障方案</th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>被保人</td>
          <td>
            {{ tableShowData.insuredInfo.sexDesc }} {{ tableShowData.insuredInfo.age }}岁
          </td>
        </tr>
        <tr v-if="tableShowData.applicantInfo">
          <td>投保人</td>
          <td>
            {{ tableShowData.applicantInfo.sexDesc }} {{ tableShowData.applicantInfo.age }}岁
          </td>
        </tr>
        <tr>
          <td>投保产品</td>
          <td>
            <p v-for="o in tableShowData.tableList" :key="JSON.stringify(o)">
              {{ o.companyName || '' }} - {{ o.titleName }}
            </p>
          </td>
        </tr>
        <tr>
          <td>保险期间</td>
          <td>{{ mainInsurance.iDurationDesc }}</td>
        </tr>
        <tr>
          <td>缴费期间</td>
          <td>{{ mainInsurance.pPeriodDesc }}</td>
        </tr>
        <tr>
          <td>主险保额</td>
          <td>{{ mainInsurance.baoeDp }}</td>
        </tr>
        <tr>
          <td>首年保费</td>
          <td>
            {{ tableShowData.totalBaof }}
          </td>
        </tr>
        <tr class="table-bg">
          <td>保障内容</td>
          <td />
        </tr>
        <template v-for="(liabilities, i) in liabilityByCategory">
          <tr
            v-for="(liability, name, index) in liabilities.data"
            :key="`${i}-${index}`"
          >
            <td>{{ name }}</td>
            <td>
              <div
                v-for="item in liability"
                class="description1"
                v-html="item.parsedDesc1"
              />
            </td>
          </tr>
          <tr v-if="liabilities.notag">
            <!-- 常规类型数据无 -->
            <td>其他</td>
            <td>
              <div
                v-for="(item, index) in liabilities.notag"
                :key="`${i}-${index}`"
                class="description1"
                v-html="item.parsedDesc1"
              />
            </td>
          </tr>
        </template>
      </tbody>
    </table>
    <div v-if="isShowBusinessCard" class="card_image_wrap">
      <img :src="cardImageData" alt="">
    </div>
  </div>
</template>
<style scoped>
@import './table.css';
.table-layout {
  border-bottom: 5px solid #ccc;
  & thead tr th:first-child,
  & tbody tr td:first-child {
    width: 38.2%;
  }
}
</style>